export default class Magazine {
  constructor() {
    this.handler = '.js-filter-item';
    this.handleFilterByType();
  }

  handleFilterByType() {
    $(this.handler).on('click', (e) => {
      const $this = $(e.currentTarget);

      if ($this.hasClass('active')) return;
      $this.addClass('active').parent().siblings().find(this.handler).removeClass('active');
      $.spinner().start();
      $.ajax({
        url: $this.attr('data-url'),
        type: 'GET',
        dataType: 'html',
        success(data) {
          const $container = $('.js-magazine-content-grid');

          if (data) {
            $container.empty();
            $(data).appendTo($container);
            $.spinner().stop();
          } else {
            $.spinner().stop();
          }
        },
        error() {
          $.spinner().stop();
        }
      });
    });
  }
}
